export enum PaymentStatus {
  Pending = 1,
  Paid = 2,
  Canceled = 3,
  Refunded = 4,
}

export enum PaymentMethod {
  Balance = 1,
  Stripe = 2,
  Alipay = 3,
  Wechat = 4,
}
